import axios from 'axios'

export const sparkVideosClient = axios.create({
  baseURL: process.env.EXPO_PUBLIC_SPARKVIDEOS_URL,
  timeout: 15000,
})
